package com.tfc.care.tfccare.domain.repository

import com.russhwolf.settings.Settings
import tfccare.composeapp.generated.resources.Res

class AppSettings(private val settings: Settings) {

    private val key = "tfcCare983748"

    private fun encrypt(value: String): String {
        return value.mapIndexed { i, c ->
            (c.code xor key[i % key.length].code).toChar()
        }.joinToString("") { it.code.toString(16).padStart(4, '0') }
    }

    private fun decrypt(value: String): String {
        return value.chunked(4)
            .mapIndexed { i, hex ->
                (hex.toInt(16) xor key[i % key.length].code).toChar()
            }.joinToString("")
    }


    private fun Settings.getEncrypted(key: String, default: String = ""): String {
        val raw = getStringOrNull(key) ?: return default
        return try { decrypt(raw) } catch (e: Exception) { default }
    }

    private fun Settings.putEncrypted(key: String, value: String) {
        putString(key, encrypt(value))
    }

    var username: String
        get() = settings.getEncrypted("o2ji3joi2j32ho3hh")
        set(value) { settings.putEncrypted("o2ji3joi2j32ho3hh", value) }


    var pwd: String
        get() = settings.getEncrypted("ijfiwou82un9038ur2903u928u")
        set(value) { settings.putEncrypted("ijfiwou82un9038ur2903u928u", value) }

    var token: String
        get() = settings.getEncrypted("23982u938u2n983nuf")
        set(value) { settings.putEncrypted("23982u938u2n983nuf", value) }


    var isLoggedIn: Boolean
        get() = settings.getEncrypted("2o3iu2io3jn2oi3h29302i093i29i392i").toBooleanStrictOrNull() ?: false
        set(value) { settings.putEncrypted("2o3iu2io3jn2oi3h29302i093i29i392i", value.toString()) }

    fun clear() = settings.clear()
}

